/**
 * Výčet barevných témat aplikace
 */
export enum ApplicationTheme {
    light = "light",
    dark = "dark",
}
